@import 'styles/variables';
@import 'styles/mixins';

.pill {
  @include md-regular;
  white-space: nowrap;
  padding: 2px 8px;
  border-radius: 16px;
  color: var(--pill-color);
  background: var(--pill-bg-color);
  display: inline-flex;
  align-items: center;
  gap: 2px;

  &.withFrontIcon {
    padding-left: 6px;
  }
}

.smallPill {
  @include sm-regular;
  height: 20px;
}
